import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import { styled } from '@mui/material'

export const StyledIcon = styled(FontAwesomeIcon)<FontAwesomeIconProps>(() => ({}))
